import { SECURITY_JWT_KEY } from "config/globals"

export const clearToken = () => {
    return localStorage.removeItem(SECURITY_JWT_KEY)
}
